import React from 'react';

export const Transportation = () => {
  return <div className="h-[400px] w-full"></div>;
};
